<template>
  <div>
    <section aria-labelledby="history-title">
      <card extra-classes="bg-white sm:rounded-lg sm:overflow-hidden">
        <div class="divide-y divide-gray-200">
          <div class="px-4 py-5 sm:px-6">
            <h2 id="notes-title" class="text-lg font-medium text-gray-900">History</h2>
          </div>
          <div class="px-4 py-6 sm:px-6">
            <SimpleRecordList
              :columns="['updated by', 'field changed', 'from', 'to', 'updated at']"
              :records="contact.history"
            />
          </div>
        </div>
      </card>
    </section>
  </div>
</template>

<script>
import Card from '../Card/index.vue';
import SimpleRecordList from '../shared/SimpleRecordList.vue';

export default {
  props: ['contact'],
  components: {
    Card,
    SimpleRecordList,
  },
};
</script>
